"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _Button = _interopRequireDefault(require("../../Button"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _styledComponents = require("styled-components");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        ", " {\n            ", "\n        }\n\n        &:hover ", " {\n            ", "\n        }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var iconOpacityHelper = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.disabled ? props.appearanceOpacityDisabled : props.appearanceOpacity;
}),
    iconOpacityHelperHover = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return props.disabled ? props.appearanceOpacityDisabled : props.appearanceOpacityHover;
}),
    PAGE_SEPARATOR = '..',
    Div = _createStyled["default"].div(_templateObject3()),
    Icon = _createStyled["default"].div(_templateObject4()),
    IconButton = _createStyled["default"].div(_templateObject5(), Icon, iconOpacityHelper, Icon, iconOpacityHelperHover);

function template() {
  var _this = this;

  var increment = null,
      decrement = null;

  var styles = this.compileStyled(_index["default"]),
      pageList = this._getPagesRow(),
      content = [],
      _this$props = this.props,
      incrementButton = _this$props.incrementButton,
      totalPages = _this$props.totalPages,
      decrementButton = _this$props.decrementButton,
      className = _this$props.className,
      page = _this$props.page,
      _this$props$theme = _this$props.theme,
      gutter = _this$props$theme.palette.gutter,
      IncrementIcon = _this$props$theme.incrementAppearance,
      DecrementIcon = _this$props$theme.decrementAppearance,
      appearanceOpacity = _this$props$theme.appearanceOpacity,
      appearanceOpacityHover = _this$props$theme.appearanceOpacityHover,
      appearanceOpacityDisabled = _this$props$theme.appearanceOpacityDisabled,
      currentPage = page instanceof Array ? page : [page],
      incrementDisabled = this.isPageSelected(totalPages),
      decrementDisabled = this.isPageSelected(1);

  if (incrementButton) {
    increment = _react["default"].createElement(IconButton, {
      styles: styles.incrementButton,
      disabled: incrementDisabled,
      appearanceOpacity: appearanceOpacity,
      appearanceOpacityHover: appearanceOpacityHover,
      appearanceOpacityDisabled: appearanceOpacityDisabled
    }, _react["default"].createElement(_Button["default"], {
      onClick: this.toNext,
      disabled: incrementDisabled,
      square: true
    }, _react["default"].createElement(Icon, {
      styles: styles.icon
    }, _react["default"].createElement(IncrementIcon, {
      width: gutter * 3,
      height: gutter * 3
    }))));
  }

  if (decrementButton) {
    decrement = _react["default"].createElement(IconButton, {
      styles: styles.decrementButton,
      disabled: decrementDisabled,
      appearanceOpacity: appearanceOpacity,
      appearanceOpacityHover: appearanceOpacityHover,
      appearanceOpacityDisabled: appearanceOpacityDisabled
    }, _react["default"].createElement(_Button["default"], {
      onClick: this.toPrev,
      disabled: decrementDisabled,
      square: true
    }, _react["default"].createElement(Icon, {
      styles: styles.icon
    }, _react["default"].createElement(DecrementIcon, {
      width: gutter * 3,
      height: gutter * 3
    }))));
  }

  pageList.forEach(function (item, i) {
    var selectedIndex = currentPage.indexOf(item),
        next = pageList[i + 1];
    var style = styles.page;

    if (selectedIndex >= 0) {
      if (currentPage.length === 1) {
        style = styles.pageSelectedSingle;
      } else if (selectedIndex === 0) {
        style = styles.pageSelectedStart;
      } else if (selectedIndex === currentPage.length - 1) {
        style = styles.pageSelectedEnd;
      } else {
        style = styles.pageSelected;
      }

      content.push(_react["default"].createElement(Div, {
        key: item,
        styles: style,
        onClick: function onClick() {
          return _this.toPage(item);
        }
      }, _react["default"].createElement(Div, {
        styles: styles.pageWrapperSelected
      }, item)));

      if (next && item + 1 < next) {
        content.push(_react["default"].createElement(Div, {
          key: item + 1,
          styles: styles.separatorSelected
        }, PAGE_SEPARATOR));
      }
    } else {
      content.push(_react["default"].createElement(Div, {
        key: item,
        styles: style,
        onClick: function onClick() {
          return _this.toPage(item);
        }
      }, _react["default"].createElement(Div, {
        styles: styles.pageWrapper
      }, item)));

      if (next && item + 1 < next) {
        content.push(_react["default"].createElement(Div, {
          key: item + 1,
          styles: styles.separator
        }, PAGE_SEPARATOR));
      }
    }
  });
  return _react["default"].createElement(Div, {
    styles: styles.root,
    className: className
  }, decrement, content, increment);
}